import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form"

export default class extends Controller {
  connect() {
    if (this.element.tagName !== "FORM") {
      return
    }
    let submitAction = "turbo:submit-start->form#submitHandler"
    let actions = this.element.dataset.action?.split(" ") || [];
    if (!actions.includes(submitAction)) {
      actions.push(submitAction)
      this.element.dataset.action = actions.join(' ')
    }
  }

  submitHandler(event) {
    let modelId = this.getModelId()
    let signalControllerElement = document.querySelector("[data-controller='turbo-list-signaling']")
    if (modelId && signalControllerElement) {
      signalControllerElement.dataset.turboListSignalingSuppressForIdValue = modelId
    }
  }

  getModelId() {
    // Gets the model id from the form action URL or hidden input field
    let transactionIdElement = this.element.querySelector("input[type=hidden][name*='[transaction_id]']")
    let formAction = this.element.action || ""
    let actionURL = new URL(formAction)
    let UrlSegments = actionURL.pathname.split('/').filter(Boolean);
    let modelId = UrlSegments.length > 0 ? UrlSegments.pop() : null;
    if (!this.isValidUUID(modelId)) {
      modelId = null
    }
    return modelId || transactionIdElement?.value
  }

  isValidUUID(str) {
    let uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
    return uuidRegex.test(str);
  }
}
